module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-plus-fed951d151758101329bd974f5a66fba.svg";